import React from 'react';
import GenreReportTemplate from './GenreReportTemplate';
import { fetchProgramsByCategoryKeywords } from '../reportsApi';
import type { ReportComponentProps } from '../reportDefinitions';

const PoetryProgramsReport: React.FC<ReportComponentProps> = () => {
  return (
    <GenreReportTemplate
      reportId="poetry-programs"
      defaultKeywords={['poetry']}
      fetcher={(keywords) =>
        fetchProgramsByCategoryKeywords(keywords, {
          reportId: 'poetry-programs',
          includeProgramMetadata: true
        })
      }
      title="Programs with poetry categories"
      subtitle="Every program listed here currently offers at least one poetry-focused category in BAM."
      emptyMessage="No poetry programs were found. Try refreshing to ensure the data is up to date."
      emphasisNote="Includes categories matched by name, tier, or subcategory containing ‘poetry’; program name matches are also surfaced when applicable."
      noteLabel="poetry"
    />
  );
};

export default PoetryProgramsReport;
